import React, { FC } from "react";

import { useInsuranceFilters } from "../Utils/Context/filtersContext";
import { addOrRemoveItemInArray } from "../Utils/addOrRemoveItemInArray";

import { Keyword } from "../Partials/Keyword";
import { List } from "../Partials/List";
import { InsuranceKeyword } from "@apiModels/Insurance/InsuranceKeyword.csharp";

export const KeywordsList: FC<{}> = () => {
  const { keywords, setKeywords } = useInsuranceFilters();

  const renderSelectedLocations = (keyword: InsuranceKeyword) => {
    const newKeywords = keywords
      ? addOrRemoveItemInArray(keywords, keyword)
      : [];

    return (
      <li key={`${keyword.name}`}>
        <Keyword
          isSelected
          label={keyword.name}
          onClick={() => setKeywords(newKeywords)}
        />
      </li>
    );
  };

  if (!keywords) return <></>;

  return (
    <List<InsuranceKeyword>
      items={keywords}
      renderItem={renderSelectedLocations}
      useDefaultLayout={false}
      listClassName="locationsList"
    />
  );
};
